import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class ReportsEditorRoute extends Route {
	@service('model-manager/board-previews')
	declare mmBoardPreviewsService: Service.ModelManager.BoardPreviews;
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;
	@service('model-manager/report-schedule-settings')
	declare mmReportScheduleSettingsService: Service.ModelManager.ReportScheduleSettings;
	@service('model-manager/reminders') declare mmRemindersService: Service.ModelManager.Reminders;
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('router') declare routerService: Service.Router;
	@service('billing') declare billingService: Service.Billing;

	constructor() {
		// eslint-disable-next-line prefer-rest-params
		super(...arguments);

		this.routerService.on('routeWillChange', (transition) => {
			// An aborted transition (e.g. held by the leave guard) keeps the editor on screen.
			if (transition.isAborted) {
				return;
			}

			const isFromReportEditorRoute = transition.from?.find(
					(route) => route.name === this.routeName,
				),
				isToAnotherRoute = !transition.to?.find((route) => route.name === this.routeName);
			if (isFromReportEditorRoute && isToAnotherRoute) {
				this.mmBoardPreviewsService.clearAllRequestedPreviews();
			}

			// Redirect https://app.databox.com/reports/editor/ to https://app.databox.com/reports/editor/null
			// https://app.asana.com/0/1138028810573038/1209226660717593/f
			if (transition.to?.name === 'reports.editor.index') {
				this.navigationService.transitionToRoute('reports.editor.report', 'null');
			}
		});
	}

	override beforeModel(): Promise<unknown> {
		document.body.id = 'page-report-editor';

		const promises: Promise<unknown>[] = [];
		promises.push(this.navigationService.initialRequestsPromise);
		promises.push(this.mmReportsService.requestReports());
		promises.push(this.mmMetricsService.requestMetrics());

		// non-blocking
		void this.mmRemindersService.requestReminders();
		void this.mmReportScheduleSettingsService.requestReportSchedules();
		void this.mmTemplatesService.requestReportAccountTemplates();

		return Promise.all(promises);
	}

	override afterModel(): void {
		if (!this.billingService.reportsBasicEnabled) {
			this.navigationService.replaceRoute('reports.index');
		}
	}
}
